import React, { useState, useEffect } from "react";
import { requestWithToken } from "../../utils/apis";
import { Spinner } from "react-bootstrap";
import { bucketUrl } from "../../utils/helper";

const SectionsGrid = ({ activeTab, onSelectItem, setSectionListData}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchItems = async () => {
      setLoading(true);
      try {
        let endpoint = "";
        if (activeTab === "sections")
          endpoint = "/api/sectionType/list?page=1&limit=100&sort=label&order=asc";
        else if (activeTab === "templates") endpoint = "/api/section/list?page=1&limit=10&is_template=true";
        else {
          setItems([]);
          setLoading(false);
          return;
        }

        const response = await requestWithToken("GET", endpoint);
        if (response?.status === 200) {
          setItems(response.data.data.list || []);
          if (activeTab === "sections" && setSectionListData) {
            setSectionListData(response.data.data.list || [])
          }
        } else {
          setItems([]);
        }
      } catch (error) {
        console.error("Error fetching", activeTab, error);
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    fetchItems();
  }, [activeTab]);

  if (loading)
    return (
      <div className="text-center">
        <Spinner size="md" />
      </div>
    );

  if (items.length === 0) return <div className="theme-card p-3 mb-3"><div className="text-center p-6">No {activeTab} available.</div></div>;
 

  return (
    <div className="theme-card p-3 mb-3">
      <div className="secwrap">
        <div className={activeTab === "sections" ? "sec-flex" : "temp-flex"}>
          {items.map((item) => (
            <div
              key={item.id}
              className={activeTab === "sections" ? "sec-flex-item" : "temp-flex-item"}
              style={{ cursor: "pointer" }}
              onClick={() => onSelectItem && onSelectItem(item)}
            >
              <div
                className={
                  activeTab === "sections"
                    ? "sec-flex-item-card"
                    : "temp-flex-item-card"
                }
              >
                <img
                  className={
                    activeTab === "sections" ? "sec-image-thumb" : "temp-image-thumb"
                  }
                  src={activeTab === "sections" ? bucketUrl + item.image : bucketUrl + item?.section_type_id?.image}
                  alt={item.label || "Item"}
                  title={item.label || "Item"}
                />
                <div className={`${activeTab === "sections" ? "sec-title" : "temp-title"}`}>
                  {item.label || item?.section_type_id?.label || ""}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionsGrid;
